var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeactivateAcc({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 359.559,
    height: 350,
    viewBox: "0 0 359.559 350",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#3f3d56;}.b{fill:#facb1f;}.c{fill:#e5e5e5;}.d{opacity:0.2;}.e{fill:#cbcbcb;}.f{fill:#f1f1f1;}.g{fill:#ffb7b7;}.h{fill:#2f2e41;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.029)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M915.6,747.541s.275-5.759,5.909-5.089",
    transform: "translate(-596.325 -438.135)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 2.82,
    cy: 2.82,
    r: 2.82,
    transform: "translate(314.867 298.286)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 0.796,
    height: 5.572,
    transform: "translate(317.228 305.854)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M321.187,290.413q0,2.115-.137,4.2a63.551,63.551,0,0,1-5.955,23.072c-.027.062-.058.119-.084.177-.159.336-.323.672-.491,1a62.787,62.787,0,0,1-3.382,5.968,63.863,63.863,0,0,1-52.413,29.5l.632,36.357,8.245-4.341,1.472,2.8-9.655,5.084,1.18,67.523.013.9-6.375,1.419.013-.906,2.007-108.831a63.736,63.736,0,0,1-45.092-19.619c-.4-.416-.8-.844-1.189-1.269-.018-.018-.031-.035-.044-.049a64,64,0,0,1-11.644-18.019c.062.071.128.137.19.208A63.943,63.943,0,0,1,228.8,233.186c.221-.111.447-.217.668-.327a63.992,63.992,0,0,1,82.9,25.167c.389.654.765,1.322,1.127,1.994A63.594,63.594,0,0,1,321.187,290.413Z",
    transform: "translate(-193.345 -150.31)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 83.791,
    cy: 83.791,
    r: 83.791,
    transform: "translate(35.445 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M296.326,117.084a83.8,83.8,0,0,0,139.621,88.682,83.8,83.8,0,1,1-139.621-88.682Z",
    transform: "translate(-238.959 -89.259)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M269.209,422.966l-8.559-2.4.018-.92,2.564-139.378.128-6.949,0-.2.447-24.35.65-35.3v0l.442-23.925h.234l.451,25.919.588,33.735.42,23.938v.177l.018.986v0l.813,46.661.084,4.637,1.68,96.439Z",
    transform: "translate(-145.438 -105.749)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 15.653,
    height: 4.144,
    transform: "translate(118.942 216.816) rotate(-27.766)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "e",
    width: 39.509,
    height: 0.884,
    transform: "translate(78.086 334.085)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "e",
    width: 39.509,
    height: 0.884,
    transform: "translate(150.586 349.116)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "e",
    width: 39.509,
    height: 0.884,
    transform: "translate(263.316 337.622)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M837.565,704.025V678.308S847.587,696.541,837.565,704.025Z",
    transform: "translate(-552.786 -402.378)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M815.056,714.523l-18.945-17.392S816.32,702.078,815.056,714.523Z",
    transform: "translate(-529.658 -412.88)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M394.565,718.025V692.308S404.587,710.541,394.565,718.025Z",
    transform: "translate(-305.626 -410.189)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M372.056,728.523l-18.945-17.392S373.32,716.078,372.056,728.523Z",
    transform: "translate(-282.498 -420.691)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M548.565,752.122v-31.98S561.028,742.814,548.565,752.122Z",
    transform: "translate(-391.546 -425.718)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M520.575,765.175l-23.558-21.627S522.147,749.7,520.575,765.175Z",
    transform: "translate(-362.786 -438.777)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M418.686,702.749l-.243.853-74.194-21.131-55.892,12.321L216.877,707l-.1-.027-33.854-9.5-8.559-2.4-26.14-7.338-21.8,4.858-6.375,1.419L106.19,697.1l-.19-.862,14.062-3.134,6.348-1.415,21.843-4.867.106.027,26.025,7.3,8.523,2.392,34.013,9.549,71.263-12.17,56.091-12.365.11.027Z",
    transform: "translate(-59.156 -380.258)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M695.729,169.79l5.656-4.524c-4.394-.485-6.2,1.912-6.938,3.809-3.433-1.425-7.17.443-7.17.443l11.317,4.109A8.564,8.564,0,0,0,695.729,169.79Z",
    transform: "translate(-468.937 -116.105)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M225.729,165.79l5.656-4.524c-4.394-.485-6.2,1.912-6.939,3.809-3.433-1.425-7.17.443-7.17.443l11.317,4.109A8.564,8.564,0,0,0,225.729,165.79Z",
    transform: "translate(-206.713 -113.873)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M667.729,360.79l5.656-4.524c-4.394-.485-6.2,1.912-6.938,3.808-3.433-1.425-7.17.443-7.17.443l11.317,4.109a8.564,8.564,0,0,0-2.865-3.836Z",
    transform: "translate(-453.315 -222.668)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M398.156,731.534l4.323,1.606,8.252-15.91-6.38-2.37Z",
    transform: "translate(-222.156 -398.836)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M587.566,802.6l8.514,3.163h0a5.788,5.788,0,0,1,3.41,7.442l-.066.176L585.485,808.2Z",
    transform: "translate(-412.145 -471.723)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M494.391,740.283H499l2.194-17.788H494.39Z",
    transform: "translate(-275.847 -403.096)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M685.927,813.469h9.083a5.788,5.788,0,0,1,5.788,5.787v.188h-14.87Z",
    transform: "translate(-468.184 -477.787)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M608.879,534.007l1.5-3.009,12.79,6.395-.376,2.633,2.445,3.2s4.138,2.257,3.386,9.781l-.752,7.147-.94,9.216,6.583,22.758L636.9,622.22l2.445,24.263-11.849-.564-10.909-39.5-19.185,42.508-13.166-3.385L602.3,603.411l2.257-17.68s-1.5-9.4,5.643-15.8l-1.129-3.386v-4.172l-3.762-19.9Z",
    transform: "translate(-411.45 -320.19)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "d",
    width: 0.442,
    height: 30.486,
    transform: "translate(196.652 256.949) rotate(-15.751)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 18.433,
    height: 1.881,
    transform: "translate(216.238 251.058) rotate(180)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "a",
    cx: 0.752,
    cy: 1.881,
    rx: 0.752,
    ry: 1.881,
    transform: "translate(215.486 248.425)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 10.027,
    cy: 10.027,
    r: 10.027,
    transform: "translate(194.317 204.143) rotate(-61.337)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "h",
    cx: 8.871,
    cy: 8.871,
    r: 8.871,
    transform: "translate(183.711 178.833)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M603.08,476.586a8.871,8.871,0,1,0,17.3,3.638,8.871,8.871,0,0,1-17.3-3.638Z",
    transform: "translate(-421.756 -289.833)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M656.43,488.857a10.488,10.488,0,1,1-6.258-8.443c1.752-1.413,3.924-.975,5.689.516,2,1.686,2.589,2.844,4.138,5.616C658.476,486.76,657.953,488.643,656.43,488.857Z",
    transform: "translate(-440.061 -291.487)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M599.438,549.469c.112,2.972.335,8.821.335,9.119,0,.315,4.434,9.5,6.35,13.447v0c.136.279.258.531.367.753a1.781,1.781,0,0,0,1.637,1.006l8.372-.15a1.784,1.784,0,0,0,1.753-1.739l.934-36.832a.91.91,0,0,0-.91-.934h-10.8a2.427,2.427,0,0,0-2.184,1.371l-5.182,10.72a6.853,6.853,0,0,0-.675,3.236Z",
    transform: "translate(-419.927 -321.944)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M641.475,571.494a23.975,23.975,0,0,0,5.72-4.835,26.529,26.529,0,0,0,6.612-15.423c.426-4.895-.546-8.533-2.887-10.814a9.528,9.528,0,0,0-7.2-2.459l-.181.021-2.744,2.322.777.918,2.456-2.078a8.39,8.39,0,0,1,6.062,2.147c2.063,2.018,2.911,5.329,2.518,9.84a25.334,25.334,0,0,1-6.281,14.693,23.278,23.278,0,0,1-5.433,4.615Z",
    transform: "translate(-443.004 -324.059)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 0.401,
    height: 14.933,
    transform: "matrix(0.201, -0.98, 0.98, 0.201, 182.809, 233.834)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 23.295,
    height: 0.401,
    transform: "matrix(0.041, -0.999, 0.999, 0.041, 191.582, 235.463)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M599.437,566.678c.112,2.972.335,8.821.335,9.119,0,.315,4.434,9.5,6.35,13.447l-3.571-20.733a4.57,4.57,0,0,0-2.968-3.525A6.727,6.727,0,0,0,599.437,566.678Z",
    transform: "translate(-419.926 -339.154)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M648.135,648.239a3.527,3.527,0,0,1,1.147-5.286l-.726-8.028,4.771-1.631.866,11.351a3.547,3.547,0,0,1-6.058,3.593Z",
    transform: "translate(-446.685 -377.264)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M641.986,550.073a5.5,5.5,0,0,1,3.723-5.633,5,5,0,0,1,3.144,0,5.5,5.5,0,0,1,3.728,5.238l.358,40.769-8.454.307Z",
    transform: "translate(-443.659 -327.549)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeactivateAcc);
export default __webpack_public_path__ + "static/media/deactivate-acc.0e9972b26cc8a2940f6790d7cad49deb.svg";
export { ForwardRef as ReactComponent };